import type { Language } from '../settings/schema.ts';
import { en, type Translation } from './en.ts';
import { it } from './it.ts';

export { en, it };
export type { Translation };

export const NAMESPACES = Object.keys(en) as readonly (keyof Translation)[];

/** i18next `resources` object: one entry per language, one namespace per top-level key. */
export const resources: Record<Language, Translation> = { en, it };

type Path<T, P extends string = ''> = {
  [K in keyof T & string]: T[K] extends string
    ? `${P}${K}`
    : T[K] extends object
      ? Path<T[K], `${P}${K}.`>
      : never;
}[keyof T & string];

/** Every translation key as `namespace.path.to.key`. */
export type TranslationKey = Path<Translation>;

/** Flattens a translation tree to `dotted.key → string`. Used by tests and tooling. */
export function flattenKeys(tree: object, prefix = ''): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(tree as Record<string, unknown>)) {
    const key = prefix ? `${prefix}.${k}` : k;
    if (typeof v === 'string') out[key] = v;
    else if (v !== null && typeof v === 'object') Object.assign(out, flattenKeys(v, key));
  }
  return out;
}
